import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Product } from '../../../types/Product';
import { calculatePriceDistribution } from '../../../utils/statistics/charts';

interface PriceDistributionChartProps {
  products: Product[];
}

export const PriceDistributionChart: React.FC<PriceDistributionChartProps> = ({ products }) => {
  const data = calculatePriceDistribution(products);

  return (
    <div>
      <h4 className="text-lg font-medium mb-4">Distribución de Precios</h4>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis 
              dataKey="range" 
              tick={{ fill: '#4B5563', fontSize: 12 }}
            />
            <YAxis 
              tick={{ fill: '#4B5563' }}
              tickFormatter={(value) => `${value}%`}
            />
            <Tooltip 
              formatter={(value: number) => [`${value}%`, 'Productos']}
              contentStyle={{ backgroundColor: 'white', borderRadius: '0.5rem' }}
            />
            <Bar 
              dataKey="percentage" 
              fill="#F97316" 
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};